module.exports = __webpack_public_path__ + "static/media/hourglass_gold_fullbdbacc1a36890d6387d85d8b796e2989.webp";